"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.StyledSelect = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
exports.StyledSelect = styled_components_1.default('select')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", "px ", "px;\n  border-width: 0;\n  border-radius: ", "px;\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n\n  &:placeholder {\n    color: ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", "px ", "px;\n  border-width: 0;\n  border-radius: ", "px;\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n\n  &:placeholder {\n    color: ", ";\n  }\n"])), accessors_1.space('sm'), accessors_1.space('md'), accessors_1.borderRadius('md'), accessors_1.textColor('contrast'), accessors_1.color('secondary', 'darkest'), accessors_1.fontFamily('sansSerif'), accessors_1.fontSize('base'), accessors_1.textColor('contrast'));
exports.Select = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(exports.StyledSelect, __assign({}, props, { ref: ref }), children));
});
exports.default = exports.Select;
var templateObject_1;
